// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"21cd0a65","53":"a6aa242a","216":"8c26e73a","301":"3a59d6e0","361":"5ea7c9bf","372":"de8807b1","421":"2eda29b9","507":"6396a6fb","530":"c2a8cda6","813":"1e415126","922":"f5244148"}[chunkId] + ".js";
};